import { devLog } from '@/utils'
import { toast } from '@/utils/ui'
import { Platform } from 'quasar'

const { cordova } = window
const SOUND_PLAYER_STATUS_STOP = 0
const SOUND_PLAYER_STATUS_PLAY = 1

export class SoundPlayer {
  _media = null
  _loop = false
  _status = SOUND_PLAYER_STATUS_STOP

  constructor (soundUrl) {
    this.setSound(soundUrl)
  }

  createVirtualMedia (url) {
    const audio = new Audio(url)
    return {
      play: async () => {
        try {
          audio.loop = this._loop
          await audio.play()
        } catch (e) {
          devLog('error createVirtualMedia ', e)
        }
      },
      setVolume: () => {},
      stop: () => {
        audio.pause()
      },
      release: () => {}
    }
  }

  setSound (url) {
    try {
      const { Media } = window
      const _url = `${cordova && Platform.is.android
        ? cordova.file.applicationDirectory + 'www/'
        : ''}${url}`
      this._media = Media
        ? new Media(
          _url,
          () => {
            devLog('Lecture du fichier audio : OK')
          },
          () => {
            devLog('Lecture du fichier audio : Echec...', url)
          },
          (e) => {
            switch (e) {
              case Media.MEDIA_STARTING: {
                devLog('stating')
                break
              }
              case Media.MEDIA_RUNNING: {
                devLog('running')
                break
              }
              case Media.MEDIA_PAUSED: {
                devLog('pause')
                break
              }
              case Media.MEDIA_STOPPED: {
                devLog('stop')
                if (this._status === SOUND_PLAYER_STATUS_PLAY && this._loop) {
                  this._play()
                }
                break
              }
              default: {
                devLog('Changed to ' + e)
              }
            }
          })
        : this.createVirtualMedia(url)
    } catch (e) {
      devLog(e)
      toast.negative('Échec lors du chargement du fichier audio')
    }
  }

  _play () {
    this._media.play()
    this._media.setVolume(1.0)
  }

  play ({ loop = false }) {
    try {
      this._status = SOUND_PLAYER_STATUS_PLAY
      if (loop) {
        this._loop = true
      }
      this._play()
    } catch (e) {
      devLog(e)
      toast.negative('Échec de la lecture du fichier audio')
    }
  }

  stop () {
    this._status = SOUND_PLAYER_STATUS_STOP
    this._media.stop()
    this._media.release()
  }
}
